import { BreadcrumbItem, Breadcrumbs } from '@nextui-org/react';
import Title from '../Components/DetailPaint/titel';
import { AxiosPublic, BaseURL } from '../config/axios';
import { useEffect, useState } from 'react';


const AboutUs = () => {
    const [desc, setDesc] = useState()
    const [data, setData] = useState([])

    useEffect(() => {
        const get = async () => {
            await AxiosPublic.get('/about-us')
                .then(res => setDesc(res.data.data.body))
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
            await AxiosPublic.get('/member')
                .then(res => setData(res.data.data.data))
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
        }
        get()
    }, [])

    return (
        <>
            <title>درباره ما</title>
            <section className='my-8'>
                <div className="container" dir='rtl'>
                    <Breadcrumbs separator='/' className='pr-6' itemClasses={{ separator: "px-2" }}>
                        <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
                        <BreadcrumbItem>درباره ما</BreadcrumbItem>
                    </Breadcrumbs>
                    <div className='flex flex-col p-4'>
                        <Title title='داستان ما' className="md:text-3xl mb-4" />
                        <div className="lg:p-4 p-2">
                            <div className="ql-editor" dangerouslySetInnerHTML={{ __html: desc }} />
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-main text-white py-12 px-4 mb-12">
                <div className="container mx-auto" dir='rtl'>
                    <Title title='تیم ما' className="md:text-3xl mb-4" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                        {data.map((member, index) => (
                            <div key={index} className="flex flex-col items-center w-full h-fit">
                                <div className="mb-4 centerOfParent max-w-full w-full h-[400px] overflow-hidden">
                                    <img
                                        src={BaseURL + member.images[0]?.path}
                                        alt={member.title}
                                        width={100} height={100}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <h3 className="md:text-xl font-semibold">{member.title}</h3>
                                <p className="text-yellow-500">{member.post}</p>
                                <p className=" md:text-sm text-xs mt-4 px-4 line-clamp-1">{member.post}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutUs;